module.exports = __webpack_public_path__ + "img/sign-out.9e2616bd.svg";